import React from 'react';
import { FinancesSummary, FinancesClients } from 'components';

export const ManagerFinances = () => {
  return (
    <div className="flex flex-col w-full gap-y-6">
      <div className="flex justify-between">
        <p className="nunito-title uppercase">Finances</p>
        {/* <OrangeButton label='View invoice' onClick={() => setIsModalVisible(true)} />
        {isModalVisible && <InvoiceHistory
          isOpen={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          partnerId={partnerId}
          role={ROLE_TYPES.slh_manager}
        />} */}
      </div>
      <FinancesSummary isManager />
      <FinancesClients />
    </div>
  );
};
